// ============================================================================
// note-client-mod -- Mod 定义
//
// 提供：
// 1. 用户中心 Slot — "我的笔记"管理面板（写操作，需要登录）
// 2. 公开页面    — /notes 笔记列表 + /notes/:id 笔记详情（给访客浏览）
// 3. NoteApiClient — HTTP API 客户端（支持 DI 注入 IFetchService）
// ============================================================================
import { USER_CENTER_SLOTS_INTERFACE_TAG } from '@hvsin/user-center-contracts';
import { PAGE_ROUTE_REGISTRY_INTERFACE_TAG } from '@hvsin/ui-registry-contracts';
import { FETCH_SERVICE_INTERFACE_TAG } from '@hvsin/fetch-contracts';
import { NoteRegistrar } from './note-registrar.js';
import { NoteApiClient } from './note-api-client.js';
export const noteClientMod = {
    name: 'note-client',
    serviceDefs: [
        {
            serviceTag: 'noteRegistrar',
            serviceImpl: NoteRegistrar,
            dependencies: [
                USER_CENTER_SLOTS_INTERFACE_TAG,
                PAGE_ROUTE_REGISTRY_INTERFACE_TAG,
                FETCH_SERVICE_INTERFACE_TAG,
            ],
        },
        {
            serviceTag: 'noteApiClient',
            serviceImpl: NoteApiClient,
            dependencies: [FETCH_SERVICE_INTERFACE_TAG],
        },
    ],
};
//# sourceMappingURL=mod.js.map